import BannerList from './banner-list';

export default BannerList;
export { BannerList };